<template>
  <v-card>
    <v-card-title class="headline"
      >Detalles del mandando
      <v-btn
        style="right: 10px; top: 10px"
        icon
        color="primary"
        fab
        absolute
        @click="$emit('cancel')"
      >
        <v-icon dark>fa-times</v-icon>
      </v-btn>
    </v-card-title>

    <v-card-text>
      <v-container>
        <v-row v-for="(point, index) of order.points" :key="index">
          <v-col cols="2" sm="2" md="2">
            <div class="index">{{ index + 1 }}</div>
          </v-col>

          <v-col
            :cols="order.tookanData ? 8 : 10"
            :sm="order.tookanData ? 8 : 10"
            :md="order.tookanData ? 8 : 10"
          >
            <h3>{{ point.address }}</h3>
            <p class="mt-3"><b>Responsable</b>: {{ point.name }}</p>
            <p><b>Teléfono</b>: {{ point.phone }}</p>
            <p><b>Descripción</b>: {{ point.instructions }}</p>
          </v-col>
          <!-- <v-col
            v-if="
              order.tookanData &&
              trackingStatus.includes(order.progressCurrentStatus)
            "
            cols="2"
            sm="2"
            md="2"
          >
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon class="map-icon" @click="showMap(index)" v-on="on">
                  fas fa-map-marked-alt
                </v-icon>
              </template>
              <span>Ver mapa</span>
            </v-tooltip>
          </v-col> -->
        </v-row>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  props: ["order"],
  name: "order-details",

  data() {
    return {
      trackingStatus: ["accepted", "enRoute", "onDelivery"],
    };
  },

  methods: {
    showMap(index) {
      let tookanPoints = [
        ...this.order.tookanData.pickups,
        ...this.order.tookanData.deliveries,
      ];

      if (tookanPoints[index] && tookanPoints[index].result_tracking_link) {
        let url = tookanPoints[index].result_tracking_link;
        window.open(url);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.index {
  width: 35px;
  height: 35px;
  background-color: #f06a25;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  color: white;
  font-weight: bold;
}

.map-icon {
  color: #818181;
  cursor: pointer;
}
</style>